"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NinetailedPrivacyPlugin = exports.DEFAULT_ACCEPTED_CONSENT_CONFIG = exports.DEFAULT_PRIVACY_CONFIG = exports.PLUGIN_NAME = void 0;
const tslib_1 = require("tslib");
const experience_js_shared_1 = require("@ninetailed/experience.js-shared");
const experience_js_1 = require("@ninetailed/experience.js");
const wildcard_match_1 = tslib_1.__importDefault(require("wildcard-match"));
const radash_1 = require("radash");
const experience_js_plugin_analytics_1 = require("@ninetailed/experience.js-plugin-analytics");
exports.PLUGIN_NAME = 'ninetailed:privacy';
exports.DEFAULT_PRIVACY_CONFIG = {
    allowedEvents: ['page'],
    allowedPageEventProperties: ['*'],
    allowedTrackEventProperties: [],
    allowedTrackEvents: [],
    allowedTraits: [],
    blockProfileMerging: true,
    enabledFeatures: [],
};
exports.DEFAULT_ACCEPTED_CONSENT_CONFIG = {
    allowedEvents: ['page', 'track', 'identify', 'component'],
    allowedPageEventProperties: ['*'],
    allowedTrackEventProperties: ['*'],
    allowedTrackEvents: ['*'],
    allowedTraits: ['*'],
    blockProfileMerging: false,
    enabledFeatures: Object.values(experience_js_shared_1.FEATURES),
};
const PAGE_EVENT_HANDLER = `page:${experience_js_1.PLUGIN_NAME}`;
const TRACK_EVENT_HANDLER = `track:${experience_js_1.PLUGIN_NAME}`;
const IDENTIFY_EVENT_HANDLER = `identify:${experience_js_1.PLUGIN_NAME}`;
class NinetailedPrivacyPlugin extends experience_js_plugin_analytics_1.NinetailedPlugin {
    constructor(config, acceptedConsentConfig) {
        super();
        this.name = exports.PLUGIN_NAME;
        this._instance = null;
        this._ready = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.queue = [];
        this.initialize = ({ instance }) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            this._instance = instance;
            instance.on('setItemEnd', ({ payload: { key } }) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (key === experience_js_1.CONSENT) {
                    yield this.enableFeatures(this.getConfig().enabledFeatures);
                }
            }));
            yield this.enableFeatures(this.getConfig().enabledFeatures);
            this.registerWindowHandlers();
            this._ready = true;
        });
        this.ready = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._ready;
        });
        this.loaded = () => {
            return this._ready;
        };
        this.handleEventStart = (eventType, 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        modifyPayloadFn) => 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ({ payload, abort }) => {
            if (!this.getConfig().allowedEvents.includes(eventType)) {
                this.queue.push(payload);
                return abort();
            }
            if (typeof modifyPayloadFn === 'function') {
                return modifyPayloadFn(payload, abort);
            }
            return payload;
        };
        this.pageStart = this.handleEventStart('page');
        this[_a] = this.handleEventStart('page', (payload) => {
            const properties = this.pickAllowedKeys(payload.properties, this.getConfig().allowedPageEventProperties);
            if (!(0, radash_1.isEqual)(payload.properties, properties)) {
                experience_js_shared_1.logger.info('[Ninetailed Privacy Plugin] Some properties were removed from the page event, as they are not allowed to send by your configuration. The following properties were kept:', properties);
            }
            return Object.assign(Object.assign({}, payload), { properties });
        });
        this.trackStart = this.handleEventStart('track');
        this[_b] = this.handleEventStart('track', (payload, abort) => {
            if (!this.getConfig().allowedTrackEvents.includes('*') &&
                !this.getConfig().allowedTrackEvents.includes(payload.event)) {
                experience_js_shared_1.logger.info('[Ninetailed Privacy Plugin] The track event was blocked, as it is not allowed to send by your configuration.');
                this.queue.push(payload);
                return abort();
            }
            const properties = this.pickAllowedKeys(payload.properties, this.getConfig().allowedTrackEventProperties);
            if (!(0, radash_1.isEqual)(payload.properties, properties)) {
                experience_js_shared_1.logger.info('[Ninetailed Privacy Plugin] Some properties were removed from the track event, as they are not allowed to send by your configuration. The following properties were kept:', properties);
            }
            return Object.assign(Object.assign({}, payload), { properties });
        });
        this.identifyStart = this.handleEventStart('identify');
        this[_c] = this.handleEventStart('identify', (payload) => {
            const traits = this.pickAllowedKeys(payload.traits, this.getConfig().allowedTraits);
            if (!(0, radash_1.isEqual)(payload.traits, traits)) {
                experience_js_shared_1.logger.info('[Ninetailed Privacy Plugin] Some traits were removed from the identify event, as they are not allowed to send by your configuration. The following traits were kept:', traits);
            }
            if (this.getConfig().blockProfileMerging && payload.userId) {
                experience_js_shared_1.logger.info('[Ninetailed Privacy Plugin] Profile merging is blocked. The userId will be ignored.');
            }
            const userId = this.getConfig().blockProfileMerging ? '' : payload.userId;
            return Object.assign(Object.assign({}, payload), { traits, userId });
        });
        this[_d] = this.handleEventStart(experience_js_1.COMPONENT);
        this.methods = {
            consent: this.consent.bind(this),
        };
        this.config = Object.assign(Object.assign({}, exports.DEFAULT_PRIVACY_CONFIG), config);
        this.acceptedConsentConfig = Object.assign(Object.assign({}, exports.DEFAULT_ACCEPTED_CONSENT_CONFIG), acceptedConsentConfig);
    }
    get instance() {
        if (!this._instance) {
            throw new Error('The Ninetailed Privacy Plugin was not initialized correctly. Please make sure to call the initialize method before using it.');
        }
        return this._instance;
    }
    consent(accepted) {
        if (accepted) {
            this.instance.storage.setItem(experience_js_1.CONSENT, 'accepted');
        }
        else {
            this.instance.storage.removeItem(experience_js_1.CONSENT);
        }
    }
    isConsentGiven() {
        const consent = this.instance.storage.getItem(experience_js_1.CONSENT);
        return consent && consent === 'accepted';
    }
    registerWindowHandlers() {
        if (typeof window === 'undefined') {
            return;
        }
        try {
            window.ninetailed = Object.assign({}, window.ninetailed, {
                consent: this.consent.bind(this),
            });
        }
        catch (error) {
            window.ninetailed = Object.assign({}, window.ninetailed, {
                consent: () => {
                    console.warn(`The ninetailed privacy plugin consent method could not get initialized.`);
                },
            });
        }
    }
    getConfig() {
        if (!this.isConsentGiven()) {
            return this.config;
        }
        return this.acceptedConsentConfig;
    }
    pickAllowedKeys(object, allowedKeys) {
        if (allowedKeys.includes('*')) {
            return object;
        }
        const matchFunctions = allowedKeys.map((key) => (0, wildcard_match_1.default)(key));
        return (0, experience_js_shared_1.pickBy)(object, (_, key) => matchFunctions.filter((match) => match(key)).length > 0);
    }
    enableFeatures(features) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.instance.dispatch({
                type: experience_js_1.SET_ENABLED_FEATURES,
                features,
            });
        });
    }
}
exports.NinetailedPrivacyPlugin = NinetailedPrivacyPlugin;
_a = PAGE_EVENT_HANDLER, _b = TRACK_EVENT_HANDLER, _c = IDENTIFY_EVENT_HANDLER, _d = experience_js_1.COMPONENT_START;
//# sourceMappingURL=NinetailedPrivacyPlugin.js.map